module.exports = __webpack_public_path__ + "img/US_RangedArmor_ua.6cf1722d.webp";